module.exports = __webpack_public_path__ + "img/demo.dc86019c.png";